import { render, staticRenderFns } from "./MoquAccountManage.vue?vue&type=template&id=bd82fd2c&scoped=true"
import script from "./MoquAccountManage.vue?vue&type=script&lang=js"
export * from "./MoquAccountManage.vue?vue&type=script&lang=js"
import style0 from "./MoquAccountManage.vue?vue&type=style&index=0&id=bd82fd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd82fd2c",
  null
  
)

export default component.exports